import { call, put, takeEvery } from 'redux-saga/effects';
import { createInstance, createInstanceSuccess, trackEvent, trackPageView } from './analytics.reducer';
import { ensureAnalyticsTransport, sendAnalyticsEvent, sendAnalyticsPageView } from '../../libs/helpers/analytics';

export const createInstanceSaga = function* () {
    yield call(ensureAnalyticsTransport);
    yield put(createInstanceSuccess());
};

export const trackPageViewSaga = function* ({ payload }) {
    yield call(sendAnalyticsPageView, payload);
};

export const trackEventSaga = function* ({ payload }) {
    const { name, params } = payload;
    yield call(sendAnalyticsEvent, name, params || {});
};

const analyticsSaga = function* () {
    yield takeEvery(createInstance.type, createInstanceSaga);
    yield takeEvery(trackPageView.type, trackPageViewSaga);
    yield takeEvery(trackEvent.type, trackEventSaga);
};

export default analyticsSaga;
